export const FORM_SUBMIT = 'redux-form-submit-actions/FORM_SUBMIT'
